export enum ButtonModifiers {
  BLOCK = 'block',
  SMALL = 'small',
  REVERSED = 'reversed'
}
